module.exports = __webpack_public_path__ + "img/header-weddingRingsPlatinum.d3f30e9.jpg";